module.exports = __webpack_public_path__ + "static/media/3.fb6baf36.jpg";